Vue.component('ack-video-carousel', {
    delimiters: ['${', '}$'],
    template: '#ack-video-carousel',
    mounted(){
      gsap.fromTo('.video-item', {opacity: 0, scale: 0.5}, {duration: 1, opacity: 1, scale: 1, stagger: 0.2} );
      //this.scrollToTop()
      console.log('ack-video-carousel mounted')
    },
    props:{
      numberOfVideosInSlider: {
        type: Number,
        default: 3,
        //required: true,
        validator: function (value) {
          return value >= 0
        }
      },
      videos: {
        type: Array,
        required: true
      },
      displaying:{
        type: Boolean,
        default: true
      },
      title:{
        type: String,
        default: null
      },
      titleClass:{
        type: String,
        default: ''
      },
      isMobile: {
        type: Boolean,
        required: true
      }
    },
    data: function () {
      return {
        firstVideo: 0,
        selectedVideo: null
      }
    },

    computed: {
      responsiveNumberOfVideosInSlider() {
        return this.isMobile ? 1 : this.numberOfVideosInSlider;
      },
      isMobile(){
        return this.$parent.isMobile
      },
      titleHyphenated(){
        return this.title.replaceAll(' ', '-')
      },
      displayedVideos() {
          let arr = []
          for (let index = this.firstVideo; index < (this.numberOfVideosInSlider + this.firstVideo); index++) {
              const element = this.videos[index]
              arr.push(element)
          }
          return arr
      },
      currentVideoTitle(){
          return this.videos[this.selectedVideo].title
      },
      currentVideoURL(){
          return this.videos[this.selectedVideo].src
      },
      currentVideo(){
        return this.videos[this.selectedVideo]
      },
      canGoNext(){
          return (this.videos.length) > (this.firstVideo + this.numberOfVideosInSlider )
      },
      canGoPrevious(){
          return ( this.firstVideo > 0 )
      }
    },
    methods: {
  
      scrollToTop(){
        window.scrollTo({
            top: 115,
            left: 100, 
            behavior: 'smooth'
        })
      },
  
      selectVideo(index){
          this.selectedVideo = index
          this.openVideo()
      },
  
      openVideo(){
        this.$emit('open-video', this.currentVideo)
      },
  
      
      goNext(){
          if( this.canGoNext ){
              this.firstVideo = this.firstVideo + 1
  
              gsap.fromTo('#'+this.titleHyphenated+'-item-2', {opacity: 0, scale: 0.5}, {duration: 1, opacity: 1, scale: 1} );
          }
      },
      goPrevious(){
          if(this.canGoPrevious){
              this.firstVideo = this.firstVideo - 1
  
              gsap.fromTo('#'+this.titleHyphenated+'-item-0', {opacity: 0, scale: 0.5}, {duration: 1, opacity: 1, scale: 1} );
          }
      },
  
      searchByTag(tag){
        this.$emit('search-by-tag', tag)
      },
  
      searchByType(type){
        this.$emit('search-by-type', type)
      },
  
      startDrag(event, item){
        event.dataTransfer.dropEffect = 'move'
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('itemIndex', item.index)
      },
  
      onDrop(event, item){
        const itemIndex = event.dataTransfer.getData('itemIndex')
        if(item.index > itemIndex){
          this.goNext()
        } else{
          this.goPrevious()
        }
  
      }
    }
  })